import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";

const mainCitiesInJordan = [
    'Amman', 'Aqaba', 'Zarqa', 'Irbid', 'Mafraq', 'Madaba', 'Karak', 'Salt', 'Tafilah'
];

export default function BookingSection() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const [selectedService, setSelectedService] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [formStatus, setFormStatus] = useState({ success: null, message: '' });

    const handleServiceChange = (e) => {
        setSelectedService(e.target.value);
    };

    const handleCityChange = (e) => {
        setSelectedCity(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormStatus({ success: null, message: '' });

        const formData = new FormData(e.target);
        try {
            const response = await fetch('https://aqaba-seasons.com/send_form.php', {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();
            setFormStatus({
                success: result.success,
                message: result.message,
            });
        } catch (error) {
            setFormStatus({
                success: false,
                message: 'An error occurred. Please try again.',
            });
        }
    };

    return (
        <section className="booking-section relative py-[40px]">
            <div className="relative container flex flex-col h-full justify-center gap-[20px]">
                <div className="js-scroll fade-top text-[25px] text-white font-bold">{t("Book Your Aqaba Season Experience")}</div>
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-[12px]">
                        <div className="f-col flex items-center gap-[12px]">
                            <div className="w-100 flex flex-col gap-[7px]">
                                <label className="js-scroll fade-top text-white font-bold">{t("Full Name")}</label>
                                <input
                                    className="js-scroll fade-btm w-100 w-[375px] p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-white"
                                    type="text"
                                    placeholder={t("Enter Your Name")}
                                    required
                                    name="fullName"
                                />
                            </div>
                            <div className="w-100 flex flex-col gap-[7px]">
                                <label className="js-scroll fade-top text-white font-bold">{t("Email")}</label>
                                <input
                                    className="js-scroll fade-btm w-100 w-[375px] p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-white"
                                    type="email"
                                    placeholder={t("Enter Your Email")}
                                    required
                                    name="email"
                                />
                            </div>
                        </div>
                        <div className="f-col flex items-center gap-[12px]">
                            <div className="w-100 flex flex-col gap-[7px]">
                                <label className="js-scroll fade-top text-white font-bold">{t("The Service")}</label>
                                <select
                                    className="js-scroll fade-btm w-100 w-[375px] p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-[#8a909a]"
                                    value={selectedService}
                                    onChange={handleServiceChange}
                                    required
                                    name="service"
                                >
                                    <option value="" disabled>{t("Select Your Service")}</option>
                                    <option value="Fashions">Fashions</option>
                                    <option value="Events">Events</option>
                                    <option value="Graduation">Graduation</option>
                                </select>
                            </div>
                            <div className="w-100 flex flex-col gap-[7px]">
                                <label className="js-scroll fade-top text-white font-bold">{t("Phone")}</label>
                                <input
                                    className="js-scroll fade-btm w-100 w-[375px] p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-white"
                                    type="number"
                                    placeholder={t("Enter Your Phone")}
                                    required
                                    name="phone"
                                />
                            </div>
                        </div>
                        <div className="w-100 flex flex-col gap-[7px]">
                            <label className="js-scroll fade-top text-white font-bold">{t("Location")}</label>
                            <select
                                className="js-scroll fade-btm w-100 w-[375px] p-[8px] rounded-[4px] outline-none border border-white bg-transparent text-[#8a909a]"
                                value={selectedCity}
                                onChange={handleCityChange}
                                required
                                name="location"
                            >
                                <option value="" disabled>{t("Select Your City")}</option>
                                {mainCitiesInJordan.map((city, index) => (
                                    <option key={index} value={city}>
                                        {t(`${city}`)}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <button
                            type="submit"
                            className="w-fit bg-[#016E82] text-white px-[20px] py-[8px] rounded font-bold capitalize"
                        >
                            {t("Booking Now")}
                        </button>
                        {formStatus.message && (
                            <div
                                className={`text-center font-bold ${formStatus.success ? 'text-green-400' : 'text-red-400'
                                    }`}
                            >
                                {formStatus.message}
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </section>
    );
}